export const classes = {
  overlay:
    'w-[96vw] max-w-[1000px] p-6 gap-6 flex flex-col h-full overflow-hidden transition-all',
  formOverlay: 'max-w-[600px]',
  content: 'flex w-full gap-6 grow overflow-hidden',
  fieldsCard:
    'h-full shrink-0 w-[300px] px-4 pt-6 pb-4 min-h-0 bg-gradient-to-br from-white dark:bg-none dark:bg-white/[0.04] to-orange-300/40 via-orange-100/20 from-30%',
  fieldsList: 'w-full',
  formCard:
    'w-full h-full grow min-w-[350px] overflow-x-auto p-6 bg-gradient-to-br to-white from-blue-200/20 from-50% dark:bg-none dark:bg-white/[0.04]',
};
